<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="back-link" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})">
                            <i class="fas fa-long-arrow-alt-left"></i>&nbsp; <b>Home</b>
                        </a>
                    </span>
                </div>
            </div>
            <div class="profile-section pt-2">
                 <div class="transactions-container">

                  <!-- Summary Section -->
                  <div class="summary-section mb-4">
                      <div class="row">
                          <div class="col-6 col-md-3" v-for="(value, key) in summaryStats" :key="key">
                              <div class="summary-card" @click="applyFilter(key)" :class="{'active-filter': selectedFilter === key}">
                                  
                                  <div class="summary-content">
                                      <div class="summary-value">{{ value }}</div>
                                      <div class="summary-label">{{ key }}</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <!-- Filter Actions -->
                  <div class="filter-actions" v-if="selectedFilter">
                      <div class="filter-badge">
                          <i class="fas fa-filter"></i> {{ selectedFilter }}
                          <button class="clear-btn" @click="clearFilter">
                              <i class="fas fa-times"></i>
                          </button>
                      </div>
                  </div>

                    <div class="section-header">
                        <h6 class="section-title">
                            <i class="fas fa-history"></i> Transactions History
                        </h6>
                        <span class="transaction-count">{{ filteredPaymentHistoryData.length }} items</span>
                    </div>

                    <!-- Transaction Items -->
                    <div class="transactions-list">
                        <div class="transaction-card" v-for="payment in filteredPaymentHistoryData" :key="payment._id">
                            <div class="transaction-main">
                                <div class="transaction-icon-wrapper">
                                    <img :src="payment.imageUrl" alt="Product" />
                                </div>
                                <div class="transaction-info">
                                    <div class="product-name">{{ payment.productName }}</div>
                                    
                                    <div class="subscription-details" v-if="payment.subscriptionCode">
                                        <span class="detail-item">
                                            <i class="fas fa-tag"></i> {{ payment.subscriptionCode }}
                                        </span>
                                        <span class="badge-used" v-if="payment.subscriptionCodeUsed">Used</span>
                                        <span class="badge-expired" v-if="new Date(payment.expiryAt) < today">Expired</span>
                                    </div>
                                    
                                    <div class="device-info" v-if="payment.profileName">
                                        <i class="fas fa-mobile-alt"></i>
                                        <span>{{ payment.profileName }} ({{ payment.serialNumber }})</span>
                                    </div>
                                    
                                    <div class="transaction-date">
                                        <i :class="payment.expiryAt ? 'fas fa-calendar-times' : 'fas fa-calendar-plus'"></i>
                                        {{ payment.expiryAt ? 'Expires' : 'Created' }}: {{ HumanReadableDateFormat(payment.expiryAt || payment.created_at, true) }}
                                    </div>
                                </div>
                            </div>
                            
                            <div class="transaction-status">
                                <div class="amount" v-if="payment.isTrialPeriod == false">£{{ payment.priceDetails.unit_amount / 100 }}</div>
                                <!--<div class="amount-trial" v-else>Trial</div>-->
                                <span class="status-badge" :class="payment.status != 'Fail' ? 'status-success' : 'status-fail'">
                                    {{ payment.status }}
                                </span>
                            </div>
                        </div>
                        
                        <div class="empty-state" v-if="filteredPaymentHistoryData.length === 0">
                            <i class="fas fa-inbox"></i>
                            <p>No transactions found</p>
                        </div>
                    </div>
                 </div>    
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";

export default {
  name: 'Payment History',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        profileId: this.$route.query.profileId || this.$route.query.profile_id,
        serialNumber: this.$route.query.serialNumber,
        paymentHistoryData: [],
        filteredPaymentHistoryData: [],
        today: new Date(),
        summaryStats: {
          "Active Subscriptions": 0,
          "Used Subscriptions": 0,
          "Unused Subscriptions": 0,
          "Expired Subscriptions": 0,
      },
      selectedFilter: null,
    }
  },
  methods: {
    getSummaryIcon(key) {
        const icons = {
            "Active Subscriptions": "fas fa-check-circle",
            "Used Subscriptions": "fas fa-user-check",
            "Unused Subscriptions": "fas fa-box",
            "Expired Subscriptions": "fas fa-exclamation-circle"
        };
        return icons[key] || "fas fa-info-circle";
    },
    
    async getPaymentHistory() {
      await KidsService.getPaymentHistory()
        .then((response) => {
          this.paymentHistoryData = response.data.data;
          this.filteredPaymentHistoryData = this.paymentHistoryData;

          let totalSubs = 0, usedSubs = 0, expiredSubs = 0, activeSubs = 0;
          let unusedSubs = 0, devicePurchases = 0, trialSubs = 0, totalAmount = 0;

          this.paymentHistoryData.forEach(payment => {
            if (payment.subscriptionType === 'recurring' && payment.status == "Success") {
              totalSubs++;
              if (payment.serialNumber) usedSubs++;
              if (new Date(payment.expiryAt) < this.today && payment.status == "Success") expiredSubs++;
              else activeSubs++;
              if (new Date(payment.expiryAt) >= this.today && !payment.serialNumber && payment.status == "Success") {
                unusedSubs++;
              }
              if (payment.isTrialPeriod) trialSubs++;
              if (!payment.isTrialPeriod && payment.priceDetails?.unit_amount && payment.status == "Success") {
                totalAmount += payment.priceDetails.unit_amount / 100;
              }
            }
            if (payment.subscriptionType === 'one_time' && payment.status == "Success") {
              devicePurchases++;
              if (payment.priceDetails?.unit_amount && payment.status == "Success")
                totalAmount += payment.priceDetails.unit_amount / 100;
            }
          });

          this.summaryStats = {
            "Active Subscriptions": activeSubs,
            "Used Subscriptions": usedSubs,
            "Unused Subscriptions": unusedSubs,
            "Expired Subscriptions": expiredSubs,
          };

          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    
    applyFilter(filterKey) {
      this.selectedFilter = filterKey;
      this.filterPayments(filterKey);
    },

    clearFilter() {
      this.selectedFilter = null;
      this.filteredPaymentHistoryData = this.paymentHistoryData;
    },

    filterPayments(filterKey) {
      switch(filterKey) {
        case "Active Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => new Date(payment.expiryAt) >= this.today && payment.subscriptionType === 'recurring');
          break;
        case "Used Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.serialNumber && payment.subscriptionType === 'recurring');
          break;
        case "Expired Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => new Date(payment.expiryAt) < this.today && payment.subscriptionType === 'recurring');
          break;
        case "Device Purchases":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.subscriptionType === 'one_time');
          break;
        case "Trial Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.isTrialPeriod && payment.subscriptionType === 'recurring');
          break;
        case "Unused Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => 
            payment.subscriptionType === 'recurring' &&
            new Date(payment.expiryAt) >= this.today &&
            !payment.serialNumber
          );
          break;
        default:
          this.filteredPaymentHistoryData = this.paymentHistoryData;
      }
    },

    HumanReadableDateFormat(date, onlyDate = false) {
      const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
      let dt = new Date(date);
      let day = ("0" + dt.getDate()).slice(-2);
      let month = dt.getMonth();
      let year = dt.getFullYear();
      let hour = ("0" + dt.getHours()).slice(-2);
      let minute = ("0" + dt.getMinutes()).slice(-2);
      let seconds = ("0" + dt.getSeconds()).slice(-2);
      if (onlyDate == true) {
          return day + " " + monthNames[month] + " " + year;
      } else {
          return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
      }
    },
  },
  beforeMount() {
    this.getPaymentHistory();
  },
}
</script>

<style scoped>
/* Back Link */
.back-link {
    color: #2c3e50;
    text-decoration: none;
    transition: color 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.back-link:hover {
    color: #3498db;
}

/* Summary Section */
.summary-section {
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15);
}

.summary-card {
    background: white;
    border: none;
    padding: 20px 16px;
    border-radius: 12px;
    margin-bottom: 15px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    min-height: 120px;
}

.summary-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.summary-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 22px;
    flex-shrink: 0;
}

.summary-content {
    flex: 1;
    text-align: center;
    width: 100%;
}

.summary-value {
    font-size: 2rem;
    font-weight: 700;
    color: #2c3e50;
    line-height: 1;
    margin-bottom: 4px;
}

.summary-label {
    font-size: 0.7rem;
    color: #7f8c8d;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1.3;
    word-break: break-word;
}

.summary-card.active-filter {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.summary-card.active-filter .summary-icon {
    background: rgba(255, 255, 255, 0.2);
}

.summary-card.active-filter .summary-value,
.summary-card.active-filter .summary-label {
    color: white;
}

/* Filter Actions */
.filter-actions {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.filter-badge {
    background: #f8f9fa;
    border: 2px solid #667eea;
    padding: 10px 16px;
    border-radius: 50px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #667eea;
}

.clear-btn {
    background: #667eea;
    border: none;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
}

.clear-btn:hover {
    background: #764ba2;
    transform: rotate(90deg);
}

/* Section Header */
.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #e9ecef;
}

.section-title {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 10px;
}

.section-title i {
    color: #667eea;
}

.transaction-count {
    background: #f8f9fa;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 0.813rem;
    font-weight: 600;
    color: #7f8c8d;
}

/* Transactions List */
.transactions-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.transaction-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.transaction-card:hover {
    border-color: #667eea;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.12);
    transform: translateY(-2px);
}

.transaction-main {
    display: flex;
    gap: 16px;
    flex: 1;
}

.transaction-icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}

.transaction-icon-wrapper img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.transaction-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.product-name {
    font-size: 1rem;
    font-weight: 600;
    color: #2c3e50;
    line-height: 1.4;
}

.subscription-details {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.detail-item {
    font-size: 0.813rem;
    color: #7f8c8d;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.detail-item i {
    color: #667eea;
}

.badge-used,
.badge-expired {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.688rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.badge-used {
    background: #fef3e2;
    color: #f39c12;
}

.badge-expired {
    background: #fee;
    color: #e74c3c;
}

.device-info {
    font-size: 0.813rem;
    color: #7f8c8d;
    display: flex;
    align-items: center;
    gap: 8px;
}

.device-info i {
    color: #667eea;
}

.transaction-date {
    font-size: 0.75rem;
    color: #95a5a6;
    display: flex;
    align-items: center;
    gap: 6px;
}

.transaction-date i {
    color: #bdc3c7;
}

.transaction-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
}

.amount {
    font-size: 1.375rem;
    font-weight: 700;
    color: #2c3e50;
    line-height: 1;
}

.amount-trial {
    font-size: 1rem;
    font-weight: 600;
    color: #3498db;
    background: #e8f4fd;
    padding: 6px 12px;
    border-radius: 8px;
}

.status-badge {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-success {
    background: #d4edda;
    color: #27ae60;
}

.status-fail {
    background: #f8d7da;
    color: #e74c3c;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #95a5a6;
}

.empty-state i {
    font-size: 4rem;
    margin-bottom: 16px;
    opacity: 0.5;
}

.empty-state p {
    font-size: 1.125rem;
    margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .summary-section {
        padding: 15px;
    }
    
    .summary-card {
        padding: 16px;
        gap: 12px;
    }
    
    .summary-icon {
        width: 40px;
        height: 40px;
        font-size: 18px;
    }
    
    .summary-value {
        font-size: 1.5rem;
    }
    
    .transaction-card {
        flex-direction: column;
        gap: 16px;
    }
    
    .transaction-status {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    
    .section-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
}
</style>